"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEditorxDomain = void 0;
var getHostName_1 = require("./getHostName");
function isEditorxDomain() {
    return (0, getHostName_1.getHostName)().match(/editorx\.com$/);
}
exports.isEditorxDomain = isEditorxDomain;
//# sourceMappingURL=isEditorxDomain.js.map